import { Component, Emit, Prop, Vue } from 'nuxt-property-decorator'
import { Offer } from '@alao-frontend/core'

@Component
export class OfferCardMixin extends Vue {
  @Prop({ required: true, default: () => ({}), type: Object })
  protected readonly offer!: Offer

  @Prop({ required: true, default: '', type: String })
  protected readonly url!: string

  get layoutBorderColor () {
    if (this.offer.expertTip) {
      return this.offer.expertTip.bgColor
    }

    return ''
  }

  @Emit('click')
  onClick () {
    return true
  }
}
